import Role from "layouts/roles/Role";
import Manage from "layouts/roles/Manage";
import ProtectedRoute from "routes/protectedRoutes.js";
const RoleRoutes = [
  {
    route: "/role/manage/:pageNo",
    key: "manage-role",
    component: <ProtectedRoute check="logout"><Manage /></ProtectedRoute>
  },
  {
    route: "role/edit/:roleId",
    key: "EditRole",
    component: <ProtectedRoute check="logout"><Role  /></ProtectedRoute>
  },
  ];

export default RoleRoutes;
